var BookapiInsurancesResponse = /** @class */ (function () {
    function BookapiInsurancesResponse() {
        this.isOk = false;
        this.insuranceForAll = [];
        this.insurancesForOnePax = new Map();
    }
    BookapiInsurancesResponse.prototype.setIsOk = function (state) {
        this.isOk = state;
    };
    BookapiInsurancesResponse.prototype.getIsOk = function () {
        return this.isOk;
    };
    BookapiInsurancesResponse.prototype.setInsurancesForAll = function (insurancesForAll) {
        this.insuranceForAll = insurancesForAll;
    };
    BookapiInsurancesResponse.prototype.getInsurancesForAll = function () {
        return this.insuranceForAll;
    };
    BookapiInsurancesResponse.prototype.setInsurancesForOnePax = function (paxNr, paxInsurances) {
        this.insurancesForOnePax.set(paxNr, paxInsurances);
    };
    BookapiInsurancesResponse.prototype.getInsurancesForOnePax = function () {
        return this.insurancesForOnePax;
    };
    return BookapiInsurancesResponse;
}());
export { BookapiInsurancesResponse };
